import React from "react";
import "./index.scss";
import { Box, Button, Illustration, Text } from "@mbank-design/design-system/components";
import { IllustrationSize } from "@mbank-design/design-system/enums";
import * as Illustrations from "@mbank-design/design-system/illustrations";
import { setVehicleOfferButtonInsightTag } from "../../common/campaign-data-setter";
import SpecialPromotions from "../SpecialPromotions";
const PromoBanner = ({ isAfterLease, literals, urlToContactSection, handleContactModal }) => {
  if (
    !literals.promo_label_new_car_title ||
    !literals.promo_label_new_car_subtitle ||
    !literals.promo_label_new_car_illustration ||
    !literals.promo_label_afterlease_car_title ||
    !literals.promo_label_afterlease_car_subtitle ||
    !literals.promo_label_afterlease_car_illustration
  ) {
    return;
  }
  const handleButtonClick = () => {
    setLocalStorageContactPreference();
    handleContactModal(urlToContactSection);
  };

  const setLocalStorageContactPreference = () => {
    localStorage.setItem("onlyOffer", true);
    // LinkedIn Insight Tag
    // setVehicleOfferButtonInsightTag();
  };

  const convertColorLiteral = (literal) => {
    literal = literal.replaceAll("[SPAN]", "<span>");
    literal = literal.replaceAll("[/SPAN]", "</span>");

    literal = literal.replaceAll("[SPAN", "<span");
    literal = literal.replaceAll('"]', '">');
    return literal;
  };
  return (
    <div className="promo-banner">
      <div className="promo-banner__left">
        <div className="promo-banner__title">
        <Box background={"#ff8600"} padding={8} borderRadius={"small"} width={"fit-content"}>
          <Text as={"p"} color={"white30"}> 
            promocja
          </Text> 
        </Box>
          {(
            <Text
              as={"h1"}
              marginBottom={16}
            >
              zyskaj rabat <span style={{ color: "#ff8600" }}>do 2000 zł</span> <br/>z ubezpieczeniem i GAP
            </Text>
          )}
        </div>
        <div className="promo-banner__subtitle">
          {(
            <Text as={"p"} marginBottom={24}>
              już dziś skorzystaj z promocji <a href="https://mleasing.pl/pdf/promocje/wiecej-za-mniej.pdf" target="_blank" rel="noreferrer">„Więcej za mniej”</a>   
            </Text>
          )}
        </div>
        <div className="promo-banner__button">
          <a href="https://mauto.pl/formularz-kontaktowy" target="_blank" rel="noreferrer">
            <Button >zapytaj o ofertę</Button>
          </a>
        </div>
      </div>
      <div className="promo-banner__right">
        <Illustration
          size={IllustrationSize.MEDIUM}
          illustrationComponent={
            isAfterLease
              ? Illustrations[literals.promo_label_afterlease_car_illustration]
              : Illustrations[literals.promo_label_new_car_illustration]
          }
        />
      </div>
    </div>
  );
};

export default PromoBanner;
